import * as React from 'react'
import { generateMedia } from 'styled-media-query'

const mobileSize = 767
const tabletSize = 1023

const useCheckMedia = (mediaSize: number) => {
    const [width, setWidth] = React.useState(window.innerWidth)
    React.useEffect(() => {
        function handleResize() {
            const windowWidth = window.innerWidth
            setWidth(windowWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return width <= mediaSize
}

export const useCheckMobile = () => {
    return useCheckMedia(mobileSize)
}

export const useCheckMobileOrTablet = () => {
    return useCheckMedia(tabletSize)
}

export const customMedia = generateMedia({
    mobile: `${mobileSize}px`,
    tablet: `${tabletSize}px`
})
